export enum DeviceType {
  Keyboard = 'keyboard',
  Gamepad = 'gamepad',
}
